import React from 'react'
import { PageLanding, NewsletterHero } from 'components/organisms'
import styles from './PupuCheckTemplate.module.sass'
import { WContainer, Button } from '@components/atoms'
import { useTrans } from 'hooks'
import AccediAptaclub from '@components/atoms/Icons/AccediAptaclub' 
import InfoAptaclub from '@components/atoms/Icons/InfoAptaclub' 
import ScattaAptaclub from '@components/atoms/Icons/ScattaAptaclub'


const PupuCheckTemplate = ({ pagina, brand }: { pagina?: any; brand?: any }) => {
  const t = useTrans()
  return (
    <PageLanding
      pagina={pagina}
      item={{}}
      contentClassName={styles.registrazioneTemplate}
      headerLogo={brand?.newsletterLogo || brand?.image}
      headerLogoAlt={brand?.name}
      footerHideStores={!!brand}
      theme={{
        pageBgColor: brand?.newsletterPageBgColor,
        heroBgColor: brand?.newsletterHeroBgColor,
        heroTextColor: brand?.newsletterHeroTextColor,
        primaryColor: brand?.newsletterPrimaryColor,
        primaryTextColor: brand?.newsletterPrimaryTextColor,
        headBgColor: brand?.newsletterHeadBgColor,
        footerBgColor: brand?.newsletterFooterBgColor,
        footerTextColor: brand?.newsletterFooterTextColor,
      }}
    >
      <NewsletterHero
        title={brand?.newsletterTitle || pagina?.titolo}
        description={brand?.newsletterDescription || pagina?.descrizione}
        image={brand?.newsletterHeroImage || pagina?.mainImage}
        imageMobile={pagina?.previewImage}
        className={'pupucheck'}
      />
      <WContainer variant="md">
        {!!brand?.newsletterFormTopText && (
          <div
            className={styles.formIntro}
            dangerouslySetInnerHTML={{ __html: brand?.newsletterFormTopText }}
          />
        )}
        <div className={styles.containerComeFunziona}>
           <div className={styles.title}>
          {t(
            'Come funziona?'
          )}
          </div>
          <div className={styles.containerBox}>
          <div className={styles.box}>
              <div className={styles.icon}><AccediAptaclub/></div>
              <div className={styles.title}>{t('Accedi alla piattaforma Aptaclub')}</div>
              <div className={styles.description}>{t('inserendo i tuoi dati e quelli del tuo bambino')}</div>
          </div>

            <div className={styles.box}>
              <div className={styles.icon}><ScattaAptaclub/></div>
              <div className={styles.title}>{t('​Scatta una foto del pannolino ')}</div>
              <div className={styles.description}>{t('e caricala sul sito (prestando attenzione a non riprendere parti del corpo del bambino)')}</div>
          </div>

            <div className={styles.box}>
              <div className={styles.icon}><InfoAptaclub/></div>
              <div className={styles.title}>{t('Ricevi informazioni')}</div>
              <div className={styles.description}>{t('su consistenza e colore delle feci')}</div>
          </div>
        </div>
      </div>
        
        <div className={styles.containerButtom}>
        <Button label={t('Inizia il test')} href="https://www.aptashop.it/aptaclub/pupu-check" newPage={true} className={styles.round}/>
        <div className={styles.text}>
          {t(
            '* Questo servizio non fornisce diagnosi mediche, ma offre un supporto utile per comprendere meglio lo stato delle feci del tuo piccolo.'
          )}
        </div>
      </div>
      </WContainer>
    </PageLanding>
  )
}

export default PupuCheckTemplate
